// Portionsrechner: Mengen pro Person / für X Personen. Reine Logik.
// Portionsgrößen in Gramm pro Person, roh/ungekocht. Etablierte Küchen-Faustwerte.
export const LEBENSMITTEL = {
  reis: { label: "Reis", beilage: 65, hauptgericht: 110 },
  nudeln: { label: "Nudeln", beilage: 70, hauptgericht: 115 },
  spaghetti: { label: "Spaghetti", beilage: 70, hauptgericht: 115 },
  kartoffeln: { label: "Kartoffeln", beilage: 200, hauptgericht: 300 },
  risotto: { label: "Risotto-Reis", beilage: 70, hauptgericht: 90 },
  couscous: { label: "Couscous", beilage: 60, hauptgericht: 100 },
};

export const LEBENSMITTEL_KEYS = Object.keys(LEBENSMITTEL);

const num = (v) => (Number(v) || 0);

export function portion(food, personen, modus = "hauptgericht") {
  const l = LEBENSMITTEL[food];
  if (!l) throw new Error(`Unbekanntes Lebensmittel: ${food}`);
  const proPerson = l[modus] ?? l.hauptgericht;
  const p = Math.max(0, Math.round(num(personen)));
  const gesamt = proPerson * p;
  return {
    food,
    modus,
    personen: p,
    proPerson,
    gesamtGramm: gesamt,
    gesamtKg: Math.round(gesamt / 10) / 100, // 2 Nachkommastellen
  };
}
